import { products } from "../../data/products.js";
import { siteLinks } from "../../data/site.js";

export function ContactForm() {
  return `
    <form class="contact-form" data-contact-form novalidate>
      <div class="form-grid">
        <div class="field"><label for="name">Nombre <span>*</span></label><input id="name" name="name" type="text" autocomplete="name" required minlength="2" maxlength="100" /></div>
        <div class="field"><label for="company">Empresa <span>*</span></label><input id="company" name="company" type="text" autocomplete="organization" required minlength="2" maxlength="120" /></div>
        <div class="field"><label for="email">Correo <span>*</span></label><input id="email" name="email" type="email" autocomplete="email" required maxlength="254" /></div>
        <div class="field"><label for="phone">Teléfono o WhatsApp</label><input id="phone" name="phone" type="tel" autocomplete="tel" maxlength="40" /></div>
        <div class="field field-full"><label for="interest">Producto o servicio de interés <span>*</span></label><select id="interest" name="interest" required><option value="">Selecciona una opción</option>${products.map((product) => `<option>${product.name}</option>`).join("")}<option>Implementación de software</option><option>Integraciones</option><option>Automatización</option><option>Desarrollo a medida</option><option>Consultoría tecnológica</option></select></div>
        <div class="field field-full"><label for="message">Mensaje <span>*</span></label><textarea id="message" name="message" rows="5" required minlength="10" maxlength="1500" placeholder="Cuéntanos brevemente qué proceso necesitas organizar o automatizar."></textarea></div>
        <div class="honeypot" aria-hidden="true"><label for="website">Sitio web</label><input id="website" name="website" type="text" tabindex="-1" autocomplete="off" /></div>
      </div>
      <div class="form-footer">
        <p>Prepararemos el mensaje y abriremos tu aplicación de correo.</p>
        <button class="button button-primary" type="submit">Abrir correo</button>
      </div>
      <div class="form-status" role="status" aria-live="polite" data-form-status></div>
    </form>
  `;
}

export function initContactForm() {
  const form = document.querySelector("[data-contact-form]");
  if (!(form instanceof HTMLFormElement)) return;
  const status = form.querySelector("[data-form-status]");
  if (!(status instanceof HTMLElement)) return;

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    status.className = "form-status";
    status.textContent = "";

    if (!form.checkValidity()) {
      form.reportValidity();
      status.classList.add("is-error");
      status.textContent = "Revisa los campos requeridos antes de continuar.";
      return;
    }

    const formData = new FormData(form);
    if (String(formData.get("website") ?? "").trim()) return;

    /** @param {string} name */
    const value = (name) => String(formData.get(name) ?? "").trim();
    const subject = `Contacto desde GR SoftMedia — ${value("interest")}`;
    const body = [
      "Hola GR SoftMedia,",
      "",
      "Quiero conversar sobre una necesidad de mi empresa.",
      "",
      `Nombre: ${value("name")}`,
      `Empresa: ${value("company")}`,
      `Correo: ${value("email")}`,
      `Teléfono o WhatsApp: ${value("phone") || "No indicado"}`,
      `Interés: ${value("interest")}`,
      "",
      "Mensaje:",
      value("message"),
    ].join("\n");
    const mailtoUrl = `mailto:${siteLinks.contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    status.className = "form-status is-success";
    status.innerHTML = `Abrimos tu aplicación de correo. Si no se abrió, <a href="${mailtoUrl}">haz clic aquí</a>.`;
    window.location.href = mailtoUrl;
  });
}
